




import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    getModules,
    fetchSubscriptionPlans,
    saveModules,
} from "../../../Servicefile/moduleService.jsx";

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Add: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
    ),
    Edit: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
    ),
    Save: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
            <polyline points="17 21 17 13 7 13 7 21" />
            <polyline points="7 3 7 8 15 8" />
        </svg>
    ),
    Cancel: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Close: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    ToggleOn: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2">
            <rect x="2" y="6" width="20" height="12" rx="6" />
            <circle cx="16" cy="12" r="4" fill="#10b981" />
        </svg>
    ),
    ToggleOff: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#cbd5e0" strokeWidth="2">
            <rect x="2" y="6" width="20" height="12" rx="6" />
            <circle cx="8" cy="12" r="4" fill="#cbd5e0" />
        </svg>
    ),
    Mandatory: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2">
            <path d="M12 2v20M2 12h20" />
        </svg>
    ),
    Included: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="2">
            <polyline points="20 6 9 17 4 12" />
        </svg>
    ),
    Excluded: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Total: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#065f46" strokeWidth="2">
            <path d="M22 12h-4l-3 9-4-18-3 9H2" />
        </svg>
    ),
    Module: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
        </svg>
    ),
    Category: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polygon points="12 2 2 7 12 12 22 7 12 2" />
            <polyline points="2 17 12 22 22 17" />
            <polyline points="2 12 12 17 22 12" />
        </svg>
    ),
    Price: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M8 12h8" />
            <path d="M12 8v8" />
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2" />
            <line x1="8" y1="21" x2="16" y2="21" />
            <line x1="12" y1="17" x2="12" y2="21" />
            <path d="M8 7h8M8 11h6M8 15h4" />
        </svg>
    )
};

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    container: {
        padding: '1px 5px',

        minHeight: '500px'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 16px 0',
        borderBottom: '2px solid #e9ecef',
        flexWrap: 'wrap',
        gap: '12px'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    titleBadge: {
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    controls: {
        display: 'flex',
        gap: '10px',
        flexWrap: 'wrap',
        alignItems: 'center'
    },
    button: {
        padding: '10px 20px',
        borderRadius: '10px',
        border: 'none',
        fontWeight: '600',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        height: '42px',
        whiteSpace: 'nowrap'
    },
    buttonPrimary: {
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        color: 'white',
        boxShadow: '0 4px 15px rgba(230, 109, 51, 0.3)'
    },
    buttonSuccess: {
        background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
        color: 'white',
        boxShadow: '0 4px 15px rgba(5, 150, 105, 0.3)'
    },
    buttonSecondary: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    tableWrapper: {
        borderRadius: '12px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        maxHeight: '70vh',
        position: 'relative'
    },
    table: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '900px'
    },
    thead: {
        position: 'sticky',
        top: 0,
        zIndex: 10
    },
    th: {
        padding: '12px 14px',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        borderBottom: '2px solid #d45a1a',
        whiteSpace: 'nowrap'
    },
    td: {
        padding: '10px 14px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '13px',
        verticalAlign: 'middle'
    },
    categoryCell: {
        fontWeight: '600',
        color: '#475569',
        backgroundColor: '#f8fafc',
        borderRight: '1px solid #f1f5f9'
    },
    grandTotalRow: {
        background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)',
        borderTop: '2px solid #10b981'
    },
    grandTotalCell: {
        padding: '14px 16px',
        fontWeight: '700',
        fontSize: '14px',
        color: '#065f46'
    },
    badge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '4px 14px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '600'
    },
    badgeMandatory: {
        background: '#fee2e2',
        color: '#dc2626',
        border: '1px solid #fecaca'
    },
    badgeIncluded: {
        background: '#d1fae5',
        color: '#059669',
        border: '1px solid #a7f3d0'
    },
    badgeExcluded: {
        background: '#fee2e2',
        color: '#dc2626',
        border: '1px solid #fecaca'
    },
    badgeAddon: {
        background: '#e0f2fe',
        color: '#0369a1',
        border: '1px solid #bae6fd'
    },
    priceDisplay: {
        fontSize: '14px',
        fontWeight: '600',
        color: '#059669'
    },
    priceIncluded: {
        fontSize: '12px',
        fontWeight: '500',
        color: '#94a3b8'
    },
    priceInput: {
        width: '90px',
        padding: '6px 10px',
        borderRadius: '6px',
        border: '2px solid #e2e8f0',
        fontSize: '13px',
        fontWeight: '600',
        textAlign: 'center',
        color: '#059669',
        transition: 'all 0.3s ease',
        outline: 'none',
        background: 'white'
    },
    toggleSwitch: {
        position: 'relative',
        display: 'inline-block',
        width: '52px',
        height: '28px'
    },
    toggleInput: {
        opacity: 0,
        width: 0,
        height: 0
    },
    toggleSlider: {
        position: 'absolute',
        cursor: 'pointer',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#cbd5e0',
        transition: '.3s',
        borderRadius: '34px'
    },
    toggleSliderChecked: {
        backgroundColor: '#10b981'
    },
    toggleSliderBefore: {
        position: 'absolute',
        content: '""',
        height: '20px',
        width: '20px',
        left: '4px',
        bottom: '4px',
        backgroundColor: 'white',
        transition: '.3s',
        borderRadius: '50%',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
    },
    toggleSliderBeforeChecked: {
        transform: 'translateX(24px)'
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    emptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    emptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10001,
        backdropFilter: 'blur(4px)'
    },
    modal: {
        background: 'white',
        borderRadius: '16px',
        padding: '28px',
        width: '440px',
        maxWidth: '92%',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        animation: 'slideUp 0.3s ease'
    },
    modalTitle: {
        fontSize: '18px',
        fontWeight: '700',
        marginBottom: '20px',
        color: '#1a1a2e',
        borderBottom: '2px solid #f0f0f0',
        paddingBottom: '14px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    modalClose: {
        position: 'absolute',
        top: '16px',
        right: '20px',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: '#a0aec0',
        transition: 'all 0.3s ease',
        padding: '4px'
    },
    formGroup: {
        marginBottom: '16px'
    },
    label: {
        display: 'block',
        marginBottom: '6px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#4a5568'
    },
    input: {
        width: '100%',
        padding: '10px 14px',
        borderRadius: '8px',
        border: '2px solid #e2e8f0',
        fontSize: '13px',
        outline: 'none',
        transition: 'all 0.3s ease',
        boxSizing: 'border-box',
        background: 'white'
    },
    select: {
        width: '100%',
        padding: '10px 14px',
        borderRadius: '8px',
        border: '2px solid #e2e8f0',
        fontSize: '13px',
        outline: 'none',
        transition: 'all 0.3s ease',
        boxSizing: 'border-box',
        background: 'white',
        cursor: 'pointer'
    },
    modalFooter: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '10px',
        paddingTop: '16px',
        borderTop: '2px solid #f0f0f0',
        marginTop: '4px'
    },
    authWarning: {
        background: '#fefcbf',
        border: '1px solid #f6e05e',
        padding: '10px 14px',
        borderRadius: '8px',
        marginBottom: '16px',
        fontSize: '13px',
        color: '#856404',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    }
};

const SubscriptionTable = () => {
    const [selectedModules, setSelectedModules] = useState({});
    const [isEditing, setIsEditing] = useState(false);
    const [modulePrices, setModulePrices] = useState({});
    const [showAddModulePopup, setShowAddModulePopup] = useState(false);
    const [modulesData, setModulesData] = useState([]);
    const [newModule, setNewModule] = useState({
        code: '',
        description: '',
        monthlyPrice: 0,
        yearlyPrice: 0,
        subscriptionPrice: 0,
        defaultIncluded: 'INCLUDE',
        catageory: 'BASE_PLAN'
    });
    const [editingModules, setEditingModules] = useState({});
    const [loading, setLoading] = useState(false);
    const [authToken, setAuthToken] = useState('');
    const [defaultIncludedOptions] = useState([
        { value: 'INCLUDE', label: 'Include' },
        { value: 'MANDATORY', label: 'Mandatory' },
        { value: 'EXCLUDE', label: 'Exclude' }
    ]);
    const [categoryOptions] = useState([
        { value: 'BASE_PLAN', label: 'Base Platform' },
        { value: 'FEATURE_ADD_ON', label: 'Feature Add-on' },
        { value: 'ORDER_TYPE', label: 'Order Type' },
        { value: 'ORDERTYPE_ADD_ON', label: 'Order Type Add-on' },
        { value: 'SUBSCRIPTION', label: 'Subscription' },
        { value: 'COMMISSION', label: 'Commission' }
    ]);

    const API_BASE_URL = 'https://backend.maamaas.com/subscription/api';
    const planType = 'STANDARD';
    const businessVertical = 'FOOD_AND_BEVERAGES';

    const categoryDisplayNames = {
        'BASE_PLAN': 'Base Platform',
        'FEATURE_ADD_ON': 'Feature (Add-on)',
        'ORDER_TYPE': 'Order Type',
        'ORDERTYPE_ADD_ON': 'Order Type (Add-on)'
    };

    const categoryOrder = {
        'BASE_PLAN': 1,
        'ORDER_TYPE': 2,
        'FEATURE_ADD_ON': 3,
        'ORDERTYPE_ADD_ON': 4
    };

    useEffect(() => {
        const token = localStorage.getItem('authToken') ||
            localStorage.getItem('token') ||
            sessionStorage.getItem('authToken') ||
            sessionStorage.getItem('token');

        if (token) {
            setAuthToken(token);
        } else {
            console.warn('No authentication token found. API requests may fail.');
        }
    }, []);

    useEffect(() => {
        fetchModulesData();
    }, [authToken]);

    const fetchModulesData = async () => {
        try {
            setLoading(true);
            const result = await fetchSubscriptionPlans(planType, businessVertical, authToken);

            if (result.success && result.data?.modules) {
                const modules = result.data.modules;
                const sortedModules = [...modules].sort((a, b) => (a.id || 999999) - (b.id || 999999));
                const transformedModules = transformApiDataToTableFormat(sortedModules);

                setModulesData(transformedModules);

                const selectedState = {};
                const priceState = {};
                const editState = {};

                sortedModules.forEach((module) => {
                    if (module.defaultIncluded === "TOGGLE" ||
                        (module.defaultIncluded !== "MANDATORY" &&
                            module.defaultIncluded !== "INCLUDE" &&
                            module.defaultIncluded !== "EXCLUDE")) {
                        selectedState[module.code] = true;
                    }
                    priceState[module.code] = {
                        monthly: module.monthlyPrice,
                        yearly: module.yearlyPrice,
                        subscriptionPrice: module.subscriptionPrice,
                        id: module.id,
                    };
                    editState[module.code] = {
                        name: formatModuleName(module.code),
                        description: module.description,
                        monthlyPrice: module.monthlyPrice,
                        yearlyPrice: module.yearlyPrice,
                        subscriptionPrice: module.subscriptionPrice || 0,
                        defaultIncluded: module.defaultIncluded || "INCLUDE",
                        catageory: module.catageory || module.category || "BASE_PLAN",
                    };
                });

                setSelectedModules(selectedState);
                setModulePrices(priceState);
                setEditingModules(editState);
            } else {
                if (result.status === 403) {
                    alert("Authentication required. Please login first.");
                } else {
                    alert(result.message || "Failed to load modules data");
                }
            }
        } catch (error) {
            console.error("Fetch Modules Error:", error);
            alert("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    const transformApiDataToTableFormat = (apiModules) => {
        const transformed = [];
        const categoriesSeen = new Set();

        apiModules.forEach((module) => {
            let type;
            const apiCategory = module.catageory || module.category || 'BASE_PLAN';

            let category = '';
            if (!categoriesSeen.has(apiCategory)) {
                category = categoryDisplayNames[apiCategory] || apiCategory;
                categoriesSeen.add(apiCategory);
            }

            if (module.defaultIncluded === 'MANDATORY') {
                type = 'mandatory';
            } else if (module.defaultIncluded === 'INCLUDE') {
                type = 'included';
            } else if (module.defaultIncluded === 'EXCLUDE') {
                type = 'exclude';
            } else {
                type = 'toggle';
            }

            transformed.push({
                category: category,
                rawCategory: apiCategory,
                name: formatModuleName(module.code),
                code: module.code,
                description: module.description,
                type: type,
                monthlyPrice: module.monthlyPrice,
                yearlyPrice: module.yearlyPrice,
                subscriptionPrice: module.subscriptionPrice || 0,
                apiId: module.id,
                defaultIncluded: module.defaultIncluded || 'INCLUDE',
                apiCatageory: apiCategory,
                id: module.id || 999999
            });
        });

        transformed.sort((a, b) => {
            const categoryOrderA = categoryOrder[a.rawCategory] || 999;
            const categoryOrderB = categoryOrder[b.rawCategory] || 999;
            if (categoryOrderA !== categoryOrderB) {
                return categoryOrderA - categoryOrderB;
            }
            return (a.id || 999999) - (b.id || 999999);
        });

        return transformed;
    };

    const formatModuleName = (code) => {
        return code.toLowerCase()
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
    };

    const getAvailableModuleCodes = () => {
        const addedCodes = modulesData.map(module => module.code);
        const allCodes = [
            'PLATFORM_ACCESS', 'VENDOR_PROFILE', 'MENU_MANAGEMENT',
            'ORDER_MANAGEMENT', 'TABLE_ORDERS', 'DELIVERY', 'CATERING',
            'INVENTORY_MANAGEMENT', 'CHEF_MANAGEMENT', 'TEAM_MANAGEMENT',
            'PROMOTIONS', 'REPORTS', 'PAYOUTS', 'SUPPORT',
            'WALLETS', 'ACCOUNT_HISTORY', 'NOTIFICATIONS', 'COUPONS_OFFERS',
            'DINE_IN', 'TAKEAWAY', 'SETTINGS_CONTROLS', 'SUBSCRIPTION', 'REGISTRATION', 'SALES_MANAGEMENT'
        ];
        return allCodes.filter(code => !addedCodes.includes(code));
    };

    const handleModuleToggle = (moduleCode) => {
        setSelectedModules(prev => ({
            ...prev,
            [moduleCode]: !prev[moduleCode]
        }));
    };

    const handleEditClick = () => {
        setIsEditing(!isEditing);
        if (!isEditing) {
            const editState = {};
            modulesData.forEach(module => {
                editState[module.code] = {
                    name: module.name,
                    description: module.description,
                    monthlyPrice: module.monthlyPrice,
                    yearlyPrice: module.yearlyPrice,
                    subscriptionPrice: module.subscriptionPrice || 0,
                    defaultIncluded: module.defaultIncluded || 'INCLUDE',
                    catageory: module.apiCatageory || 'BASE_PLAN'
                };
            });
            setEditingModules(editState);
        }
    };

    const handlePriceChange = (moduleCode, field, value) => {
        setEditingModules(prev => ({
            ...prev,
            [moduleCode]: {
                ...prev[moduleCode],
                [field]: field.includes('Price') ? parseFloat(value) || 0 : value
            }
        }));
    };

    const handleSaveChanges = async () => {
        try {
            setLoading(true);
            const updatedModules = modulesData.map((module) => {
                const editData = editingModules[module.code];
                return {
                    id: module.apiId || 0,
                    code: module.code,
                    description: editData ? editData.description : module.description,
                    defaultIncluded: editData ? editData.defaultIncluded : module.defaultIncluded || "INCLUDE",
                    monthlyPrice: editData ? editData.monthlyPrice : module.monthlyPrice,
                    yearlyPrice: editData ? editData.yearlyPrice : module.yearlyPrice,
                    subscriptionPrice: editData ? editData.subscriptionPrice : module.subscriptionPrice,
                    catageory: editData ? editData.catageory : module.apiCatageory || "BASE_PLAN",
                };
            });

            await saveModules(businessVertical, planType, updatedModules, authToken);
            setIsEditing(false);
            alert("Changes saved successfully!");
            fetchModulesData();
        } catch (error) {
            console.error("Error saving changes:", error);
            if (error.response?.status === 403) {
                alert("Access denied. Please check your permissions or login again.");
            } else {
                alert(`Failed to save changes: ${error.response?.data?.message || error.message}`);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleAddModule = () => {
        setShowAddModulePopup(true);
        setNewModule({
            code: '',
            description: '',
            monthlyPrice: 0,
            yearlyPrice: 0,
            defaultIncluded: 'INCLUDE',
            catageory: 'BASE_PLAN'
        });
    };

    const handleSaveNewModule = async () => {
        try {
            if (!newModule.code || !newModule.description) {
                alert("Please fill in all required fields");
                return;
            }

            setLoading(true);
            const moduleToAdd = {
                code: newModule.code,
                description: newModule.description,
                monthlyPrice: parseFloat(newModule.monthlyPrice) || 0,
                yearlyPrice: parseFloat(newModule.yearlyPrice) || 0,
                subscriptionPrice: parseFloat(newModule.subscriptionPrice) || 0,
                defaultIncluded: newModule.defaultIncluded,
                catageory: newModule.catageory,
            };

            const existingModules = modulesData.map((module) => {
                const moduleData = {
                    code: module.code,
                    description: module.description,
                    defaultIncluded: module.defaultIncluded || "INCLUDE",
                    monthlyPrice: module.monthlyPrice,
                    yearlyPrice: module.yearlyPrice,
                    subscriptionPrice: module.subscriptionPrice || 0,
                    catageory: module.apiCatageory || "BASE_PLAN",
                };
                if (module.apiId && module.apiId !== 0) {
                    moduleData.id = module.apiId;
                }
                return moduleData;
            });

            if (existingModules.some((m) => m.code === moduleToAdd.code)) {
                alert("Module with this code already exists!");
                return;
            }

            const allModules = [...existingModules, moduleToAdd];
            await saveModules(businessVertical, planType, allModules, authToken);
            setShowAddModulePopup(false);
            alert("Module added successfully!");
            fetchModulesData();
        } catch (error) {
            console.error("Error adding module:", error);
            if (error.response?.status === 403) {
                alert("Access denied. You need admin privileges to add modules.");
            } else {
                alert(`Failed to add module: ${error.response?.data?.message || error.message}`);
            }
        } finally {
            setLoading(false);
        }
    };

    const calculateTotal = (period = 'monthly') => {
        let total = 0;
        modulesData.forEach(module => {
            if (module.type === 'mandatory' || module.type === 'included') {
                const price = isEditing && editingModules[module.code] ?
                    editingModules[module.code].monthlyPrice : module.monthlyPrice;
                const yearlyPrice = isEditing && editingModules[module.code] ?
                    editingModules[module.code].yearlyPrice : module.yearlyPrice;
                total += period === 'monthly' ? price : yearlyPrice;
            } else if (module.type === 'toggle' && selectedModules[module.code]) {
                const price = isEditing && editingModules[module.code] ?
                    editingModules[module.code].monthlyPrice : module.monthlyPrice;
                const yearlyPrice = isEditing && editingModules[module.code] ?
                    editingModules[module.code].yearlyPrice : module.yearlyPrice;
                total += period === 'monthly' ? price : yearlyPrice;
            }
        });
        return total;
    };

    const monthlyTotal = calculateTotal('monthly');
    const yearlyTotal = calculateTotal('yearly');
    const subscriptionTotal = modulesData.reduce((total, module) => total + Number(module.subscriptionPrice || 0), 0);
    const availableModules = getAvailableModuleCodes();

    return (
        <div style={styles.container}>
            {/* Header */}
            <div style={styles.header}>
                <div style={styles.title}>
                    📋 Subscription Modules
                    <span style={styles.titleBadge}>{modulesData.length}</span>
                </div>
                <div style={styles.controls}>
                    <button
                        style={{
                            ...styles.button,
                            ...styles.buttonPrimary,
                            opacity: !authToken ? 0.6 : 1,
                            cursor: !authToken ? 'not-allowed' : 'pointer'
                        }}
                        onClick={handleAddModule}
                        disabled={!authToken}
                    >
                        <Icons.Add /> Add Module
                    </button>
                </div>
            </div>

            {!authToken && (
                <div style={styles.authWarning}>
                    ⚠️ Read-only mode. Login with admin account to edit or add modules.
                </div>
            )}

            {/* Table */}
            <div style={styles.tableWrapper}>
                <table style={styles.table}>
                    <thead style={styles.thead}>
                        <tr>
                            <th style={{ ...styles.th, width: '14%' }}>Category</th>
                            <th style={{ ...styles.th, width: '18%' }}>Module</th>
                            <th style={{ ...styles.th, width: '22%' }}>Description</th>
                            <th style={{ ...styles.th, width: '14%', textAlign: 'center' }}>Status</th>
                            <th style={{ ...styles.th, width: '12%', textAlign: 'center' }}>Monthly (₹)</th>
                            <th style={{ ...styles.th, width: '12%', textAlign: 'center' }}>Yearly (₹)</th>
                            <th style={{ ...styles.th, width: '12%', textAlign: 'center' }}>Subscription</th>
                        </tr>
                    </thead>
                    <tbody>
                        {modulesData.length > 0 ? (
                            modulesData.map((module, index) => (
                                <tr
                                    key={`${module.code}-${module.id}`}
                                    style={{
                                        backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                        transition: 'background 0.15s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!module.category) {
                                            e.currentTarget.style.backgroundColor = '#f0f4ff';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!module.category) {
                                            e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#fafbfc';
                                        }
                                    }}
                                >
                                    <td style={{
                                        ...styles.td,
                                        ...styles.categoryCell,
                                        fontWeight: module.category ? '700' : '400',
                                        color: module.category ? '#1e293b' : '#94a3b8'
                                    }}>
                                        {isEditing && authToken ? (
                                            <select
                                                value={editingModules[module.code]?.catageory || module.apiCatageory || 'BASE_PLAN'}
                                                onChange={(e) => handlePriceChange(module.code, 'catageory', e.target.value)}
                                                style={styles.select}
                                            >
                                                {categoryOptions.map((option) => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        ) : (
                                            module.category || '—'
                                        )}
                                    </td>

                                    <td style={styles.td}>
                                        {isEditing && authToken ? (
                                            <input
                                                type="text"
                                                value={editingModules[module.code]?.name || module.name}
                                                onChange={(e) => handlePriceChange(module.code, 'name', e.target.value)}
                                                style={styles.input}
                                            />
                                        ) : (
                                            <span style={{ fontWeight: '500' }}>{module.name}</span>
                                        )}
                                    </td>

                                    <td style={styles.td}>
                                        {isEditing && authToken ? (
                                            <input
                                                type="text"
                                                value={editingModules[module.code]?.description || module.description}
                                                onChange={(e) => handlePriceChange(module.code, 'description', e.target.value)}
                                                style={styles.input}
                                            />
                                        ) : (
                                            <span style={{ color: '#64748b', fontSize: '12px' }}>{module.description}</span>
                                        )}
                                    </td>

                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        {isEditing && authToken ? (
                                            <select
                                                value={editingModules[module.code]?.defaultIncluded || module.defaultIncluded || 'INCLUDE'}
                                                onChange={(e) => handlePriceChange(module.code, 'defaultIncluded', e.target.value)}
                                                style={{ ...styles.select, width: '100%' }}
                                            >
                                                {defaultIncludedOptions.map((option) => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        ) : (
                                            module.type === 'mandatory' ? (
                                                <span style={{ ...styles.badge, ...styles.badgeMandatory }}>
                                                    Mandatory
                                                </span>
                                            ) : module.type === 'included' ? (
                                                <span style={{ ...styles.badge, ...styles.badgeIncluded }}>
                                                    Included
                                                </span>
                                            ) : module.type === 'exclude' ? (
                                                <span style={{ ...styles.badge, ...styles.badgeExcluded }}>
                                                    Excluded
                                                </span>
                                            ) : (
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                                                    <label style={styles.toggleSwitch}>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedModules[module.code] || false}
                                                            onChange={() => handleModuleToggle(module.code)}
                                                            style={styles.toggleInput}
                                                            disabled={!authToken}
                                                        />
                                                        <span style={{
                                                            ...styles.toggleSlider,
                                                            ...(selectedModules[module.code] ? styles.toggleSliderChecked : {})
                                                        }}>
                                                            <span style={{
                                                                ...styles.toggleSliderBefore,
                                                                ...(selectedModules[module.code] ? styles.toggleSliderBeforeChecked : {})
                                                            }} />
                                                        </span>
                                                    </label>
                                                    <span style={{
                                                        fontSize: '11px',
                                                        fontWeight: '600',
                                                        color: selectedModules[module.code] ? '#10b981' : '#94a3b8'
                                                    }}>
                                                        {selectedModules[module.code] ? 'Include' : 'Exclude'}
                                                    </span>
                                                </div>
                                            )
                                        )}
                                    </td>

                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        {isEditing && authToken ? (
                                            <input
                                                type="number"
                                                value={editingModules[module.code]?.monthlyPrice || module.monthlyPrice}
                                                onChange={(e) => handlePriceChange(module.code, 'monthlyPrice', e.target.value)}
                                                style={styles.priceInput}
                                                min="0"
                                                step="1"
                                            />
                                        ) : module.monthlyPrice > 0 ? (
                                            <span style={styles.priceDisplay}>₹{module.monthlyPrice.toLocaleString()}</span>
                                        ) : (module.type === 'included' || module.type === 'mandatory') ? (
                                            <span style={styles.priceIncluded}>Included</span>
                                        ) : (
                                            <span style={styles.priceDisplay}>₹0</span>
                                        )}
                                    </td>

                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        {isEditing && authToken ? (
                                            <input
                                                type="number"
                                                value={editingModules[module.code]?.yearlyPrice || module.yearlyPrice}
                                                onChange={(e) => handlePriceChange(module.code, 'yearlyPrice', e.target.value)}
                                                style={styles.priceInput}
                                                min="0"
                                                step="1"
                                            />
                                        ) : module.yearlyPrice > 0 ? (
                                            <span style={styles.priceDisplay}>₹{module.yearlyPrice.toLocaleString()}</span>
                                        ) : (module.type === 'included' || module.type === 'mandatory') ? (
                                            <span style={styles.priceIncluded}>Included</span>
                                        ) : (
                                            <span style={styles.priceDisplay}>₹0</span>
                                        )}
                                    </td>

                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        {isEditing && authToken ? (
                                            <input
                                                type="number"
                                                value={editingModules[module.code]?.subscriptionPrice || module.subscriptionPrice || 0}
                                                onChange={(e) => handlePriceChange(module.code, 'subscriptionPrice', e.target.value)}
                                                style={styles.priceInput}
                                                min="0"
                                                step="1"
                                            />
                                        ) : module.subscriptionPrice > 0 ? (
                                            <span style={styles.priceDisplay}>₹{module.subscriptionPrice.toLocaleString()}</span>
                                        ) : (module.type === 'included' || module.type === 'mandatory') ? (
                                            <span style={styles.priceIncluded}>Included</span>
                                        ) : (
                                            <span style={styles.priceDisplay}>₹0</span>
                                        )}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" style={{ padding: 0 }}>
                                    <div style={styles.emptyState}>
                                        <Icons.NoData />
                                        <div style={styles.emptyStateText}>No modules found</div>
                                        <div style={styles.emptyStateSubtext}>Add your first module to get started</div>
                                    </div>
                                </td>
                            </tr>
                        )}

                        {/* Grand Total Row */}
                        {/* {modulesData.length > 0 && (
                            <tr style={styles.grandTotalRow}>
                                <td colSpan="4" style={{ ...styles.grandTotalCell, textAlign: 'right' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'flex-end' }}>
                                        <Icons.Total /> Grand Total
                                    </div>
                                </td>
                                <td style={{ ...styles.grandTotalCell, textAlign: 'center' }}>
                                    ₹{monthlyTotal.toLocaleString()}
                                </td>
                                <td style={{ ...styles.grandTotalCell, textAlign: 'center' }}>
                                    ₹{yearlyTotal.toLocaleString()}
                                </td>
                                <td style={{ ...styles.grandTotalCell, textAlign: 'center' }}>
                                    ₹{subscriptionTotal.toLocaleString()}
                                </td>
                            </tr>
                        )} */}
                    </tbody>
                </table>

                {/* Footer Controls */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    padding: '12px 16px',
                    background: '#f8fafc',
                    borderTop: '1px solid #edf2f7',
                    borderRadius: '0 0 12px 12px'
                }}>
                    {!isEditing ? (
                        <button
                            style={{
                                ...styles.button,
                                ...styles.buttonPrimary,
                                opacity: !authToken ? 0.6 : 1,
                                cursor: !authToken ? 'not-allowed' : 'pointer'
                            }}
                            onClick={handleEditClick}
                            disabled={!authToken}
                        >
                            <Icons.Edit /> Edit
                        </button>
                    ) : (
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <button
                                style={{ ...styles.button, ...styles.buttonSecondary }}
                                onClick={() => setIsEditing(false)}
                                disabled={loading}
                            >
                                <Icons.Cancel /> Cancel
                            </button>
                            <button
                                style={{ ...styles.button, ...styles.buttonSuccess }}
                                onClick={handleSaveChanges}
                                disabled={loading || !authToken}
                            >
                                {loading ? 'Saving...' : <><Icons.Save /> Save Changes</>}
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {/* Add Module Modal */}
            {showAddModulePopup && (
                <div style={styles.modalOverlay} onClick={() => setShowAddModulePopup(false)}>
                    <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
                        <div style={{ position: 'relative' }}>
                            <button
                                style={styles.modalClose}
                                onClick={() => setShowAddModulePopup(false)}
                            >
                                <Icons.Close />
                            </button>
                            <h3 style={styles.modalTitle}>
                                <Icons.Add style={{ color: '#e66d33' }} /> Add New Module
                            </h3>
                        </div>

                        {!authToken && (
                            <div style={styles.authWarning}>
                                ⚠️ Admin access required. You need to be logged in as admin to add modules.
                            </div>
                        )}

                        <div style={styles.formGroup}>
                            <label style={styles.label}>Module Code *</label>
                            <select
                                value={newModule.code}
                                onChange={(e) => setNewModule({ ...newModule, code: e.target.value })}
                                style={styles.select}
                                disabled={!authToken}
                            >
                                <option value="">Select Module Code</option>
                                {availableModules.map(code => (
                                    <option key={code} value={code}>
                                        {formatModuleName(code)}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div style={styles.formGroup}>
                            <label style={styles.label}>Default Included</label>
                            <select
                                value={newModule.defaultIncluded}
                                onChange={(e) => setNewModule({ ...newModule, defaultIncluded: e.target.value })}
                                style={styles.select}
                                disabled={!authToken}
                            >
                                <option value="INCLUDE">Include</option>
                                <option value="MANDATORY">Mandatory</option>
                                <option value="EXCLUDE">Exclude</option>
                            </select>
                        </div>

                        <div style={styles.formGroup}>
                            <label style={styles.label}>Monthly Price (₹)</label>
                            <input
                                type="number"
                                value={newModule.monthlyPrice}
                                onChange={(e) => setNewModule({ ...newModule, monthlyPrice: e.target.value })}
                                style={{
                                    ...styles.input,
                                    backgroundColor: newModule.defaultIncluded === 'INCLUDE' ? '#f7fafc' : 'white',
                                    cursor: newModule.defaultIncluded === 'INCLUDE' ? 'not-allowed' : 'text'
                                }}
                                min="0"
                                step="1"
                                disabled={!authToken || newModule.defaultIncluded === 'INCLUDE'}
                                readOnly={newModule.defaultIncluded === 'INCLUDE'}
                            />
                        </div>

                        <div style={styles.formGroup}>
                            <label style={styles.label}>Yearly Price (₹)</label>
                            <input
                                type="number"
                                value={newModule.yearlyPrice}
                                onChange={(e) => setNewModule({ ...newModule, yearlyPrice: e.target.value })}
                                style={{
                                    ...styles.input,
                                    backgroundColor: newModule.defaultIncluded === 'INCLUDE' ? '#f7fafc' : 'white',
                                    cursor: newModule.defaultIncluded === 'INCLUDE' ? 'not-allowed' : 'text'
                                }}
                                min="0"
                                step="1"
                                disabled={!authToken || newModule.defaultIncluded === 'INCLUDE'}
                                readOnly={newModule.defaultIncluded === 'INCLUDE'}
                            />
                        </div>

                        <div style={styles.formGroup}>
                            <label style={styles.label}>Category *</label>
                            <select
                                value={newModule.catageory}
                                onChange={(e) => setNewModule({ ...newModule, catageory: e.target.value })}
                                style={styles.select}
                                disabled={!authToken}
                            >
                                {categoryOptions.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div style={styles.formGroup}>
                            <label style={styles.label}>Description *</label>
                            <input
                                type="text"
                                value={newModule.description}
                                onChange={(e) => setNewModule({ ...newModule, description: e.target.value })}
                                placeholder="Enter module description"
                                style={styles.input}
                                disabled={!authToken}
                            />
                        </div>

                        <div style={styles.modalFooter}>
                            <button
                                style={{ ...styles.button, ...styles.buttonSecondary }}
                                onClick={() => setShowAddModulePopup(false)}
                                disabled={loading}
                            >
                                Cancel
                            </button>
                            <button
                                style={{
                                    ...styles.button,
                                    ...styles.buttonPrimary,
                                    opacity: !authToken || loading ? 0.6 : 1,
                                    cursor: !authToken || loading ? 'not-allowed' : 'pointer'
                                }}
                                onClick={handleSaveNewModule}
                                disabled={loading || !authToken}
                            >
                                {loading ? 'Adding...' : 'Add Module'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <style>{`
                @keyframes slideUp {
                    from { opacity: 0; transform: translateY(30px) scale(0.95); }
                    to { opacity: 1; transform: translateY(0) scale(1); }
                }

                @media (max-width: 768px) {
                    .table-wrapper {
                        max-height: 50vh !important;
                    }
                    .table-container table {
                        font-size: 12px !important;
                    }
                    .table-container table th,
                    .table-container table td {
                        padding: 8px 10px !important;
                        font-size: 11px !important;
                    }
                    .price-input {
                        width: 70px !important;
                        padding: 4px 6px !important;
                        font-size: 11px !important;
                    }
                    .toggle-switch {
                        width: 40px !important;
                        height: 22px !important;
                    }
                    .toggle-slider-before {
                        height: 16px !important;
                        width: 16px !important;
                        left: 3px !important;
                        bottom: 3px !important;
                    }
                    .toggle-slider-before-checked {
                        transform: translateX(18px) !important;
                    }
                    .modal {
                        padding: 20px !important;
                        width: 95% !important;
                    }
                    .modal-title {
                        font-size: 16px !important;
                    }
                    .controls {
                        gap: 6px !important;
                    }
                    .button {
                        padding: 6px 12px !important;
                        font-size: 12px !important;
                        height: 34px !important;
                    }
                }

                @media (max-width: 480px) {
                    .container {
                        padding: 12px 8px !important;
                    }
                    .title {
                        font-size: 16px !important;
                    }
                    .table-container table {
                        font-size: 10px !important;
                        min-width: 700px !important;
                    }
                    .table-container table th,
                    .table-container table td {
                        padding: 4px 6px !important;
                        font-size: 10px !important;
                    }
                    .price-input {
                        width: 55px !important;
                        padding: 2px 4px !important;
                        font-size: 10px !important;
                    }
                    .badge {
                        font-size: 9px !important;
                        padding: 2px 8px !important;
                    }
                    .modal {
                        padding: 16px !important;
                        width: 98% !important;
                    }
                    .modal-title {
                        font-size: 14px !important;
                    }
                    .form-group {
                        margin-bottom: 10px !important;
                    }
                    .label {
                        font-size: 11px !important;
                    }
                    .input, .select {
                        padding: 6px 10px !important;
                        font-size: 12px !important;
                    }
                }

                ::-webkit-scrollbar {
                    width: 6px;
                    height: 6px;
                }
                ::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 4px;
                }
                ::-webkit-scrollbar-thumb {
                    background: linear-gradient(135deg, #e66d33 0%, #d45a2a 100%);
                    border-radius: 4px;
                }
                ::-webkit-scrollbar-thumb:hover {
                    background: linear-gradient(135deg, #d45a2a 0%, #b84a1a 100%);
                }
            `}</style>
        </div>
    );
};

export default SubscriptionTable;